var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex align-items-center",staticStyle:{"min-height":"50vh"}},[_c('BasePagePreloader',{attrs:{"showPreloader":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }